import React from "react";
import Finishes from './finishes.component';

interface Props {
  propertyType: any;
  finishesRail: any;
  finishesFloor: any;
  finishesMeson: any;
  finishesWoodwork: any;
  finishesList: any;
  setFinishesRail: (value: any) => void;
  setFinishesFloor: (value: any) => void;
  setFinishesMeson: (value: any) => void;
  setFinishesWoodwork: (value: any) => void;
  setFinishesList: (value: any) => void;
}

const BottombarFinishes: React.FC<Props> = ({ propertyType, finishesRail, finishesFloor, finishesMeson, finishesWoodwork, finishesList, setFinishesRail, setFinishesFloor, setFinishesMeson, setFinishesWoodwork, setFinishesList }) => {
  

  const states: any = {
    finishesRail: {
      state: finishesRail,
      setter: setFinishesRail,
    },
    finishesWoodwork: {
      state: finishesWoodwork,
      setter: setFinishesWoodwork,
    },
    finishesMeson: {
      state: finishesMeson,
      setter: setFinishesMeson,
    },
    finishesFloor: {
      state: finishesFloor,
      setter: setFinishesFloor,
    }
  };

  return (
    <div className="bottombar-menu-finishes">
      <div className="bottombar-finishes-content">
        <div className='bottombar-finishes-container-title'>Acabados</div>
        <div className='bottombar-finishes-container-options'>
          { 
            finishesList.map( (local_finishes: any, index: number) => 
              <Finishes key={local_finishes.id} finishes={local_finishes} currentFinishes={states[local_finishes.category]['state']} setCurrentFinishes={states[local_finishes.category]['setter']}/>
            )
          }
        </div>
        
      </div>
    </div>
  );
};

export default BottombarFinishes;